<template>
  <div class="logs-box" @scroll="onScroll">
    <transition name="slide-up">
      <div class="date-range" v-show="showDateRange">
        <div class="row">
          <div class="column small-6">
            <datepicker
              :format="calendarFormat"
              class="datepicker small inline"
              v-model="date.from"
              v-on:input="changeDate('from')"
              :disabled-picker="loading"
              :input-class="{'datepicker-empty':error.from}"
              :placeholder="$t('transactions.filter.from')"
            ></datepicker>
          </div>
          <div class="column small-6">
            <datepicker
              :format="calendarFormat"
              class="datepicker small inline left-side"
              v-model="date.to"
              v-on:input="changeDate('to')"
              :disabled-picker="loading"
              :input-class="{'datepicker-empty':error.to}"
              :placeholder="$t('transactions.filter.to')"
            ></datepicker>
          </div>
        </div>
        <transition name="slide-up">
          <span class="error-msg" v-if="!!error.message">{{ error.message }}</span>
        </transition>
        <button class="cta button block xsmall success" @click="dateApply">Submit</button>
      </div>
    </transition>

    <div class="list">
      <div
        v-for="(log, i) in logs"
        :key="i"
        @click="log.show = !log.show"
        :class="{'action':true, 'collapsed':log.collapsed}"
      >
        <div class="minimize">
          <div class="icon-display">
            <i class="fa fa-plus-circle" v-if="!log.show"></i>
            <i class="fa fa-minus-circle" v-else></i>
          </div>
          <div class="action-display">
            <span>{{log.created}}</span>
            <div class="log-heading">{{ title(log) }}</div>
          </div>
        </div>
        <transition name="slide-down">
          <div v-show="log.show" class="action-item">
            <div class="icon-display"></div>
            <div class="action-display">
              <div class="log-details">
                <div v-if=" log.details.packageID" class="log-data">
                  Package ID:
                  <a :href="`#/package/${log.details.packageID}`" target="_blank">{{log.details.packageID}}</a>
                </div>

                <div v-if="showRsvpId.indexOf(log.action) > -1" class="log-data">
                  Reservation ID:
                  <a :href="`#/reservation/${log.rsvpId}`" target="_blank">{{log.rsvpId}}</a>
                </div>

                <div v-if="log.action === 'consumer_cancel'" class="log-data">
                  Cancellation Fee:
                  <b>${{ toFixed(log.details.cancellationFee) }}</b>
                </div>

                <div v-if="log.action === 'create_rsvp'" class="log-data">
                  <div class="log-data">
                    Charged Amount:
                    <b>${{ toFixed(log.details.chargeAmount) }}</b>
                  </div>
                  <div class="log-data">
                    IP Address:
                    <b>{{log.details.ip}}</b>
                  </div>
                </div>

                <div v-if="log.action === 'consumer_convert' && log.details.result.creditAmount" class="log-data">
                  Amount:
                  <b>${{ toFixed(Math.abs(log.details.result.creditAmount)) }}</b>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <transition name="slide-down">
        <div class="loader" v-if="loading">
          <i class="fas fa-spinner fa-spin"></i> Loading...
        </div>
      </transition>

      <div class="empty-state" v-show="logs.length === 0 && !loading">
        <i class="fa fa-clipboard-list fa-4x"></i>
        <span>{{ $t('rsvpDetails.activityLogs.emptyState') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import services from '@/modules/api/services'
import featureToggle from '@/modules/api/featureToggle'


export default {
  name: 'logs',
  components: { datepicker },
  data () {
    return {
      heading: {
        create_rsvp: 'Created the reservation',
        pay_fail: 'Made a payment but failed',
        consumer_cancel: 'Cancelled the reservation',
        consumer_release: 'Released the driver',
        cons_mark_rtg: 'Marked the reservation as Ready to Go',
        consumer_convert: 'Set the reservation to Open Credit',
        edit_rsvp: 'Updated the reservation',
        update_fail: 'Updated the reservation but failed',
        refund_converted: 'Converted the reservation into ride credits',
        credit_reclaimed: 'Reclaimed the converted credits and refunded the charges',
        resend_email_cons: 'Requested to resend receipt email'
      },
      showRsvpId: [
        'create_rsvp', 'pay_fail', 'consumer_cancel', 'consumer_release', 'cons_mark_rtg',
        'cons_mark_rtg', 'consumer_convert', 'edit_rsvp', 'update_fail', 'refund_converted', 'credit_reclaimed', 'resend_email_cons'
      ],
      showDateRange: false,
      date: {
        from: '',
        to: ''
      },
      error: {
        from: false,
        to: false,
        message: ''
      }
    }
  },
  computed: {
    consId () { return this.$route.params.id },
    logs () { return this.$store.state.consumer.logs.list },
    loading () { return this.$store.state.consumer.logs.loading },
    reachMax () { return this.$store.state.consumer.logs.reachMax }
  },
  methods: {
    getLogs () {
      let self = this
      if (self.loading || self.reachMax) { return }

      self.$store.commit('consumer/setLogsField', {
        fields: { loading: true }
      })

      let logsData = this.$store.state.consumer.logs
      let params = {
        token: self.$store.state.session.sessionToken,
        pageNum: logsData.pageNum,
        pageSize: logsData.pageSize,
        order: 'created',
        orderAsc: 0
      }
      if (logsData.since) {
        params.since = moment(logsData.since, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00:00')
        params.until = moment(logsData.until, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59:59')
      }

      self.$sdk.get(`/consumer/${self.consId}/logs`, params, res => {
        self.$store.commit('consumer/setLogsField', {
          fields: { loading: false }
        })

        if (!res.error) {
          if (!res.list.length) {
            self.$store.commit('consumer/setLogsField', {
              fields: { reachMax: true }
            })
            return
          }

          let actions = {}
          res.list.forEach(log => {
            if (!actions[log.action]) { actions[log.action] = 0 }
            actions[log.action] = actions[log.action] + 1

            let tempLog = log
            tempLog.created = moment(tempLog.created, 'X').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, true))
            let showDefault = { show: false }
            self.$store.commit('consumer/addLogs', { ...log, ...showDefault })
          })
        }
      })
    },
    title (data) {
      return this.heading[data.action] || data.action
    },
    toFixed (x) { return parseFloat(x).toFixed(2) },
    onScroll (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.loadMore()
      }
    },
    loadMore () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('consumer/setLogsField', {
        fields: { pageNum: self.$store.state.consumer.logs.pageNum + 1 }
      })
      self.getLogs()
    },
    dateToggle (val) {
      this.showDateRange = val === 'custom'
      if (val === 'all') {
        this.$store.commit('consumer/setLogsField', {
          fields: {
            pageNum: 1,
            list: [],
            since: null,
            until: null,
            reachMax: false
          }
        })
        this.getLogs()
      }
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    changeDate (type) {
      let format = 'MM/DD/YYYY'
      let from = ''
      let to = ''

      if (type === 'from') {
        this.error.from = false
        from = moment(this.date.from)
        this.$store.commit('consumer/setLogsField', {
          fields: { since: from.format(format) }
        })
        if (this.date.to) { to = moment(this.date.to, format) }
      } else {
        this.error.to = false
        to = moment(this.date.to)
        this.$store.commit('consumer/setLogsField', {
          fields: { until: to.format(format) }
        })
        if (this.date.from) { from = moment(this.date.from, format) }
      }
    },
    dateApply () {
      if (this.loading) { return }

      this.error = {
        from: false,
        to: false,
        message: ''
      }

      if (this.date.from === '' || this.date.to === '') {
        if (this.date.to === '') { this.error.to = true }
        if (this.date.from === '') { this.error.from = true }
        this.error.message = this.$t('transactions.filter.emptyDate')
        return
      }

      let from = moment(this.date.from)
      let to = moment(this.date.to)
      if (from.format('x') > to.format('x')) {
        this.error.from = true
        this.error.to = true
        this.error.message = this.$t('transactions.filter.invalidDateRange')
        return
      }

      this.$store.commit('consumer/setLogsField', {
        fields: {
          pageNum: 1,
          list: [],
          since: from.format('MM/DD/YYYY'),
          until: to.format('MM/DD/YYYY'),
          reachMax: false
        }
      })
      this.getLogs()
    }
  },
  watch: {
    consId: function (value) {
      this.$store.commit('consumer/setLogsField', {
        fields: {
          pageNum: 1,
          list: [],
          since: null,
          until: null,
          reachMax: false
        }
      })
      this.getLogs()
    }
  },
  mounted () {
    this.getLogs()
  }
}
</script>

<style lang="scss" scoped>
.logs-box {
  background: #fff;
  border-top: 1px solid #e3e3e3;
  overflow-y: auto;
  height: calc(100% - 50px);
}

.date-range {
  padding: 20px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
  transform-origin: top center;

  .small-6:first-child {
    padding-right: 10px;
  }
  .datepicker {
    margin-bottom: 5px;
  }
  .error-msg {
    background: #ff6115;
    border-radius: 3px;
    font-size: 13px;
    color: #fff;
    display: block;
    padding: 4px;
    margin-bottom: 7px;
    font-style: italic;
    transform-origin: top center;
  }
}

.list {
  padding: 20px;
}

.action {
  border: 1px solid #ddd;
  width: 100%;
  max-height: auto;
  padding: 10px;
  background: #fafafa;
  overflow: hidden;
  transition: all 0.35s ease-in-out;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover {
    background: #fff8dc;
  }
  &.collapsed {
    padding: 10px;
    background: #fff8dc;
  }

  .log-heading {
    margin: 0;
    font-weight: 600;
  }
  .action-item {
    padding-left: 15px;
    transform-origin: top center;

    .icon-display {
      float: left;
      width: 5%;
      i {
        font-size: 11px;
        color: #666;
      }
    }

    .action-display {
      float: left;
      width: 95%;
      margin-top: 10px;
    }

    .log-details {
      font-size: 11px;
      color: #666;
    }
    .log-data {
      margin-bottom: 2px;
    }
  }

  .minimize {
    font-size: 11px;
    color: #666;
    content: "";
    clear: both;

    .icon-display {
      float: left;
      width: 5%;
      i {
        font-size: 11px;
        color: #666;
      }
    }

    .action-display {
      float: left;
      width: 95%;
      p {
        margin: 0;
      }
    }
  }
}

.loader {
  text-align: center;
  padding: 10px;
  font-size: 21px;
  color: #bbb;
  font-weight: 600;

  i {
    margin-right: 3px;
  }
}

.empty-state {
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa {
    display: block;
    margin-bottom: 5px;
    color: #ccc;
    text-shadow: 0 0 5px rgba(255, 255, 255, 1);
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.2s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter,
.slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

.service-label {
  line-height: 100%;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  display: inline-block;
  margin-top: 2px;
  text-transform: capitalize;

  &.shared {
    background: #f38d56;
  }
  &.opoli {
    background: #26d97a;
  }
  &.black {
    background: #777;
  }
  &.SUV,
  &.suv {
    background: #dc3168;
  }
  &.shuttle {
    background: #6dabc3;
  }
}

@media only screen and (max-width: 430px) {
  .list {
    padding-bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/Logs.vue